const API_URL = 'https://fortniteapi.io/v1/shop?lang=en';
const API_KEY = '201bbf9a-4701dc5a-16b3fc9b-cb82c8fa';

export {API_KEY, API_URL}